import React from 'react';
import {OrbitComponent} from '../../base-components/orbit-component/orbit-component';
import {observer} from 'mobx-react';
import {ResponsibleIconsAgeButtonConfiguration} from '../../../services/configurations/config-data-sections/header.configuration';
import {ResponsibleGamingIconsBox} from "./boxes/responsible-gaming-icons.box";

@observer
export class ResponsibleIconsComponent extends OrbitComponent<{}> {

  private _renderAgeButton(ageButtonConfig: ResponsibleIconsAgeButtonConfiguration) {
    if(ageButtonConfig && ageButtonConfig.display) {
      return (
          <div className={'cgp-directive-age_responsible_game'} data-icon-type={ageButtonConfig.iconType}></div>
      );
    }

    return null;
  }

  render() {
    let responsibleIconsConfig = this.services.configuration.data.header.responsibleIcons;
    if(!responsibleIconsConfig || !responsibleIconsConfig.display) {
      return null;
    }

    return (
        <ResponsibleGamingIconsBox className={"cy-header-responsible-gaming-icons"}>
          {this._renderAgeButton(responsibleIconsConfig.ageButton)}
          <div className={'cgp-directive-responsible_gaming_icons'}></div>
        </ResponsibleGamingIconsBox>
    );
  }
}
